<template>
  <div v-if="show" class="relative">
    <img v-if="fulfilSrc" class="db w-100" :src="src">
    <img v-else class="db loading_img" :src="url">
  </div>
</template>

<script>
  export default {
    props: { // 父组件传过来所需的url
      src: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        show: true,
        fulfilSrc: false,
        url: require('components/upLoad/loading.gif') // 先加载loading.gif
      }
    },
    mounted () {
      var newImg = new Image()
      newImg.src = this.src
      newImg.onerror = () => { // 图片加载错误时的替换图片
        this.show = false
      }
      newImg.onload = () => { // 图片加载成功后
        setTimeout(() => {
          this.fulfilSrc = true
        }, 800)
      }
    }
  }
</script>

<style lang="scss">
  .relative > .db.loading_img{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 32px;
    height: 32px;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/loading.vue